import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import { AuthService } from '@shared/services/auth.service';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'tp24';

  constructor(private swUpdate: SwUpdate, private authService: AuthService) {}

  ngOnInit(): void {
    if (this.swUpdate.isEnabled) {
      console.log('Service worker is enabled');
      this.swUpdate.versionUpdates.subscribe((event) => {
        if (event.type === 'VERSION_READY') {
          this.clearCachesAndReload();
        }
      });
    }
  }

  private async clearCachesAndReload(): Promise<void> {
    const cacheNames = await caches.keys();
    await Promise.all(cacheNames.map((name) => caches.delete(name)));
    console.log('All caches cleared, reloading...');
    window.location.reload();
  }
  
}
